import { useContext, useMemo } from 'react';

import { UserContext } from 'contexts/ConfigContext';
import { buildRouteSearchIndex, RouteSearchEntry } from 'utils/landingSearch';

/**
 * Every route the landing search can navigate to.
 *
 * `appConfig` is already merged with admin-created routes (`ConfigContext`), so embedded routes
 * an admin adds become searchable without any extra wiring.
 */
export const useSearchableRoutes = (): RouteSearchEntry[] => {
    const { appConfig } = useContext(UserContext);

    return useMemo(() => buildRouteSearchIndex(appConfig), [appConfig]);
};

export default useSearchableRoutes;
